import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { signOut } from '../modules/app'
import { push } from 'connected-react-router'
import {
  Container,
  CssBaseline,
  Typography,
  TableCell,
  TableContainer,
  Button,
  Paper,
  Table,
  TableBody,
  TableRow,
} from '@material-ui/core'
import { fetchAccounts } from '../modules/app'
import { getAccounts } from '../modules/selectors'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  table: {
    minWidth: 120,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const AccountList = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const selector = useSelector((state) => state)
  const accounts = getAccounts(selector) || []

  useEffect(() => {
    dispatch(fetchAccounts())
  }, [dispatch])

  return (
    <Container component="main">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          アカウントの一覧
        </Typography>
        <br />
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableBody>
              {accounts.length > 0 &&
                accounts.map((account) => (
                  <TableRow key={account.id}>
                    <TableCell component="th" scope="row">
                      <Button
                        onClick={() => {
                          dispatch(push('/accounts/edit/' + account.id))
                        }}
                      >
                        {account.name}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => {
                          dispatch(push(`/webbooks/${account.type}/${account.id}`))
                        }}
                      >
                        予約画面を表示
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Button
          className={classes.submit}
          variant="contained"
          color="primary"
          onClick={() => {
            dispatch(push('/accounts/edit/'))
          }}
        >
          新規作成
        </Button>
        <Button
          onClick={() => {
            dispatch(signOut())
          }}
        >
          ログアウト
        </Button>
      </div>
    </Container>
  )
}

export default AccountList
